import React from 'react';
import { Popover, Tag } from 'antd';
import styled from 'styled-components';
import Currency from '$app/components/vendor/Currency';

const PlainTag = styled(Tag)`
  font-size: 9px !important;
  font-weight: bold !important;
  letter-spacing: 0.4 !important;
`

const Wrapper = styled.div`
  color: #fa8c16;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ContentValue = styled.span`
  font-weight: bold;
  ${({ highlighted }) => highlighted && ({ color: '#fa8c16' })}
`;

const makeValue = (value = 0, isCurrency) => {
  if(isCurrency) return (
    <Currency trailingZero>{value}</Currency>
  );
  return `${value} hr`;
}

const makeContent = (fromValue, toValue, isCurrency, source = 'Quote Engine') => (
  <div style={{ color: '#666a6c' }}>
    <p style={{ margin: 0, fontSize: 13 }}>
      <ContentValue>{makeValue(fromValue, isCurrency)}</ContentValue>
      &nbsp;
      Provided by {source}
    </p>
    <p style={{ fontSize: 13 }}>
      <ContentValue highlighted>{makeValue(toValue, isCurrency)}</ContentValue>
      &nbsp;
      Changed by garage
    </p>
  </div>
);

export default function DisplayDiff({fromValue = 0, toValue = 0, isCurrency, source }) {
    return (
      <Popover content={makeContent(fromValue, toValue, isCurrency, source)} trigger="hover">
        <Wrapper>
          <PlainTag color="orange">Changed</PlainTag>
          <span style={{ minWidth: 28 }}>{makeValue(toValue, isCurrency)}</span>
        </Wrapper>
      </Popover>
    )
}
